import _ from 'lodash';
import { useState } from 'react';
import AvailableFreeTrialCard from 'common/components/AvailableFreeTrialCard';
import { webAndMobileDefaultProps, webAndMobileRootPropTypes } from 'ui/Plans/defaultProps';
import PlanTypeSelector from '../common/PlanTypeSelector';
import PlanCard from './PlanCard';
import AddonCard from './AddonCard';
import StaticIpCard from 'v3/pages/Plans/StaticIp/index.tsx';
import Credits from '../common/Credits';
import PaymentCoupons from '../common/PaymentCoupons';
import classNames from 'classnames';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const propTypes = webAndMobileRootPropTypes;
const defaultProps = webAndMobileDefaultProps;

// Get tab from URL params
const getInitialTab = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const tabParam = urlParams.get('tab');
  const validTabs = ['plans', 'addons', 'static-ip'];
  return validTabs.includes(tabParam) ? tabParam : 'plans';
};

const Web = ({
  planCycleType,
  setPlanCycleType,
  activePlanId,
  activePlanName,
  addons,
  staticIpPlans,
  userStaticIp,
  couponCode,
  setCouponCode,
  isApplied,
  appliedCouponConfig,
  creditBalance,
  setCreditBalance,
  isCreditApplied,
  freePlanDetails,
  setIsCreditApplied,
  message,
  freeTrailDays,
  currentCyclicPeriodPlans,
  currentCyclicPeriodAddons,
  plansGroupedByCyclicMonths,
  shouldShowAddons,
  isSubscriptionActive,
  planPageNotice,
  shouldShowCoupon,
  onCouponUpdate,
  productName
}) => {
  const oneIndentation = ' ';

  const [currentTab, setCurrentTab] = useState(getInitialTab);
  const {isB2b, isUserSignedIn, currentUserBroker, isCrypto} = ApplicationDomainUtility;

  const renderAddon = (addon, idx) => (
    <div className='col-lg-4'>
      <AddonCard
        couponConfig={appliedCouponConfig}
        key={idx}
        addon={addon}
        purchaseType="addon"
        credits={isCreditApplied ? creditBalance : 0}
      />
    </div>
  );

  const renderAddons = () => {
    if (!shouldShowAddons) return null;
    if (_.isEmpty(addons)) return null;

    return (
      <div className="col-lg-12 col-md-6 col-12 ">
        <div className="tab-box-three">
          <div className=" d-flex align-items-center justify-content-center gap-15">
            <div>
              <h2 className="font-weight-bold mt-3 mb-3">AddOn Credits</h2>
            </div>
          </div>
          <div className='row d-flex justify-content-center'>
            {_.map(currentCyclicPeriodAddons, renderAddon)}
          </div>
        </div>
      </div>
    );
  };

  const renderPlan = (plan, key) => {
    return (
      <div className="col-lg-4 col-md-6 col-12 mt-2 mb-3" key={key}>
        <PlanCard
          plan={plan}
          activePlanName={activePlanName}
          couponConfig={appliedCouponConfig}
          planCycleType={planCycleType}
          activePlanId={activePlanId}
          isSubscriptionActive={isSubscriptionActive}
          isCreditApplied={isCreditApplied}
          credits={isCreditApplied ? creditBalance : 0}
          couponCode={couponCode}
          onChangeCouponCode={setCouponCode}
          isApplied={isApplied}
          onCouponUpdate={onCouponUpdate}
          message={message}
          plansGroupedByCyclicMonths={plansGroupedByCyclicMonths}
        />
      </div>
    );
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const renderFreePlanDetails = () => {
    if (isUserSignedIn || isB2b) return null;

    const { historic_run_limit: historicRunLimit, live_run_limit: liveRunLimit } = freePlanDetails;
    const freeTrailInDays = _.get(freeTrailDays, 'default', 0);

    return (
      <div className="trial-card mt-5">
        <div className="container-fluid wrap mb-5">
          <div className="card">
            <div className="d-flex align-items-center justify-content-between ">
              <div className="trial-content">
                <h3 className="mb-1">
                  <p>Choose your plan. still not sure?</p>
                </h3>
                <h4>{freeTrailInDays !== 0 && `Try our ${freeTrailInDays}-day free trial.`}</h4>
                <span>
                  <b>{historicRunLimit}</b>
                  {oneIndentation}
                  Backtest,
                  {oneIndentation}
                  <b>{liveRunLimit}</b>
                  {oneIndentation}
                  Live, F&O and Equity
                </span>
              </div>
              <div className="ml-5">
                <button type="button">
                  <a href="/">
                    Start Pro Free Trial
                    <i className="fa-solid fa-circle-arrow-right ml-1" />
                  </a>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderPlanTypeSelector = () => {
    return (
      <div className="d-flex align-items-center flex-column">
        <div className="switch-btn">
        </div>
      </div>
    );
  };

  const renderPlanPageHeaders = () => {
    let headerClass = 'd-flex align-item-center gap-15 flex-column mb-3 ';
    headerClass += 'flex-wrap flex-lg-nowrap justify-content-center align-items-center';

    return (
      <>
        {currentTab == 'plans' && renderPlanTypeSelector()}
        {shouldShowCoupon && (
          <div className={headerClass}>
            {!isCrypto
              ? (<PlanTypeSelector
            planCycleType={planCycleType}
            onHandlePlanType={setPlanCycleType}
            plansGroupedByCyclicMonths={plansGroupedByCyclicMonths}
              />)
              : null}
            <Credits
              creditBalance={creditBalance}
              isCreditApplied={isCreditApplied}
              onUpdateCredits={
                (newCreditBalance, isCreditUsed) => {
                  setCreditBalance(newCreditBalance);
                  setIsCreditApplied(isCreditUsed);
                }
              }
            />
            <PaymentCoupons
              couponCode={couponCode}
              onChangeCouponCode={setCouponCode}
              isApplied={isApplied}
              onCouponUpdate={onCouponUpdate}
              message={message}
            />
          </div>
        )}

        {isSubscriptionActive
          && (
            <div className="alert alert-info d-flex align-items-center gap-10 my-2">
              Want to upgrade or extend plan?
              {oneIndentation}
              Please cancel your recurring subscription and continue with one-time payment.
            </div>
          )}
      </>
    );
  };

  const applicationDomainNotice = () => {
    if (!planPageNotice) { return null; }

    return (
      <div className="alert alert-info text-center mb-2 custom-alert">{planPageNotice}</div>
    );
  };

  // Check if current user's broker needs static IP
  const shouldShowStaticIpTab = window.SA_FEATURE_FLAGS.shouldShowStaticIpPage;
  const shouldShowAddonsTab = !_.isEmpty(addons);

  const tabConfigs = [
    { key: 'plans', label: 'Plans' },
    ...(shouldShowAddonsTab ? [{ key: 'addons', label: 'Add-ons' }] : []),
    ...(shouldShowStaticIpTab ? [{ key: 'static-ip', label: 'Static IP' }] : [])
  ];

  const renderStaticIpPlans = () => {
    if (_.isEmpty(staticIpPlans)) return null;

    // eslint-disable-next-line no-undef
    const staticIpBrokers = window.staticIpBrokers || [];
    const isIpMandatedBroker = staticIpBrokers.includes(currentUserBroker);

    let infoMessage = isIpMandatedBroker ? 'Your broker requires a user dedicated static IP.' : 'Your broker does not require a dedicated static IP.';
    infoMessage += ' Please contact support if you have any questions or refer to this blog';

    if (!isUserSignedIn) {
      infoMessage = 'For more information, Please contact support or refer to this blog';
    }

    return (
      <div className="col-lg-12 col-md-6 col-12">
        <div className="aler-message-box mb-4">
          <div className='icon-text'>
              <i className="fa-regular fa-circle-info"></i>
            {infoMessage}
            <a href="https://www.quantman.trade/blog/understanding-sebis-static-ip-requirements" target="_blank" rel="noreferrer">Read More<i className="fa-regular fa-arrow-up-right"></i></a>
          </div>
        </div>
        <div className="row d-flex justify-content-center">
            {/* {_.map(staticIpPlans, (plan, idx) => (
              <div className="col-lg-4" key={idx}>
                <StaticIpCard
                  staticIpPlan={plan}
                  credits={isCreditApplied ? creditBalance : 0}
                  userStaticIp={userStaticIp}
                  isIpMandatedBroker={isIpMandatedBroker}
                />
              </div>
            ))} */}
          <div className='col-lg-4'>
            <StaticIpCard />
          </div>
          </div>
      </div>
    );
  };

  const renderli = (liConfig) => {
      const liClassName = classNames({
        'nav-link': true, active: currentTab === liConfig.key,
      });

      return (
        <li className="nav-item" key={liConfig.key}>
          <span className={liClassName} onClick={() => setCurrentTab(liConfig.key)}>
            {liConfig.label}
          </span>
        </li>
      );
    };

  return (
    <>
      <div>
        <AvailableFreeTrialCard />
        <div className='head-pill-card'>
          <div className="d-flex align-items-center justify-content-center"><h2>{_.upperFirst(ApplicationDomainUtility.partnerName)||productName}<span className='me-2 ms-2'>Pricing</span>for Algo Traders</h2></div>

          {(ApplicationDomainUtility.isQubit || !isB2b) && (
            <ul className="nav nav-pills">
              {tabConfigs.map((tabConfig) => renderli(tabConfig))}
            </ul>
          )}
        </div>

        {applicationDomainNotice()}
        {currentTab !== 'static-ip' && renderPlanPageHeaders()}

      </div>
      <div>
        <div className="row plans-row d-flex justify-content-center flex-row-reverse">
          {currentTab === 'plans' && _.map(_.orderBy(currentCyclicPeriodPlans, 'price', 'asc'), renderPlan)}
          {currentTab === 'addons' && renderAddons()}
          {currentTab === 'static-ip' && renderStaticIpPlans()}
        </div>
      </div>
    </>
  );
};

Web.propTypes = propTypes;
Web.defaultProps = defaultProps;

export default Web;
